import styled from 'styled-components';

export const StyledBetaModal = styled.div`
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
  height: calc(100% - 40px);
  left: ${props => (props.isOpened ? '0' : '-100vw')};
  overflow-y: auto;
  position: fixed;
  top: 40px;
  transition: 0.5s ease;
  width: 100vw;
  z-index: 2500;
  padding: 1.25em 1.5em;
`;

export const StyledBetaModalHeader = styled.div`
  border-bottom: 1px solid #c8c8c8;
  display: flex;
  font-size: 1rem;
  padding: 0 0 12px;
  width: 100%;

  > svg {
    margin-right: 12px;
  }
`;

export const StyledBetaModalContent = styled.div`
  font-size: 1rem;
  overflow-y: auto;
  padding: 0;
  text-align: justify;
  flex-grow: 1;
`;

export const StyledBetaModalFooter = styled.div`
  align-items: center;
  border-top: 1px solid #c8c8c8;
  display: flex;
  justify-content: center;
  padding: 1.25rem 2rem 0;
  width: 100%;

  > small {
    color: #7c7c7c;
  }

  > button {
    appearance: none;
    background: #fc7a1e;
    border-radius: 4px;
    border: 0;
    cursor: pointer;
    font-family: inherit;
    font-size: 1rem;
    padding: 0.75em 2.5em;

    &:hover {
      background: #fb973b;
    }
  }
`;
